import React from 'react';
import Helmet from 'react-helmet';
import { withIntl, propTypes as intlPropTypes } from 'ha/i18n';

const WebSite = ({ intl: { urlResolver } }) => (
  <Helmet>
    <script type="application/ld+json">
      {JSON.stringify({
        '@context': 'http://schema.org',
        '@type': 'WebSite',
        alternateName: 'HousingAnywhere.com',
        name: 'HousingAnywhere',
        potentialAction: {
          '@type': 'SearchAction',
          'query-input': 'required name=search_term_string',
          target: `${urlResolver.absolutizePath(`/s/{search_term_string}`)}`,
        },
        url: urlResolver.absolutizePath(`/`),
      })}
    </script>
  </Helmet>
);

WebSite.propTypes = {
  intl: intlPropTypes.isRequired,
};

export default withIntl(WebSite);
